var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fnol-flow view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 2,
                textOfStep: _vm.$t("Déclaration des dommages"),
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "view_content" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _c("div", { staticClass: "form" }, [
            _c(
              "div",
              { staticClass: "components-container" },
              _vm._l(_vm.dataComponents, function (component) {
                return _c(
                  "div",
                  { staticClass: "component-container" },
                  [
                    !component.isInfoPart
                      ? [
                          component.type === "message" &&
                          component.literal != "Final del proceso" &&
                          component.literal != "Fin du processus"
                            ? _c("div", [
                                _c(
                                  "p",
                                  { staticClass: "headline-medium gray" },
                                  [_vm._v(_vm._s(component.literal))]
                                ),
                                _c("p", { staticClass: "mg mg--t-4" }, [
                                  _vm._v(_vm._s(component.content.PARAGRAPH1)),
                                ]),
                                _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "mg mg--t-4 mg--l-4 bullet",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(component.content.PARAGRAPH2)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "mg mg--t-4 mg--l-4 bullet",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(component.content.PARAGRAPH3)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "mg mg--t-4 mg--l-4 bullet",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(component.content.PARAGRAPH4)
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("p", { staticClass: "mg mg--t-4" }, [
                                  _vm._v(_vm._s(component.content.PARAGRAPH5)),
                                ]),
                              ])
                            : component.type === "text"
                            ? _c("p", [_vm._v(_vm._s(component.literal))])
                            : component.type === "date"
                            ? _c("ma-date-picker", {
                                attrs: {
                                  errorInput: _vm.errorDate,
                                  handleChangeInput:
                                    _vm.handleChangeInputDate(component),
                                  literal: component.literal,
                                  futureDates: true,
                                },
                              })
                            : component.type === "textarea"
                            ? _c("ma-input-textarea", {
                                attrs: {
                                  type: "textarea",
                                  name: component.id,
                                  col: "4",
                                  literal: component.literal,
                                  value: component.value,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : component.type === "integer" ||
                              component.type === "float" ||
                              component.type === "number"
                            ? _c("ma-input-number", {
                                attrs: {
                                  name: component.id,
                                  type: "text",
                                  col: "4",
                                  literal: component.literal,
                                  value: component.value,
                                  floatDigits: component.floatDigits,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : component.type === "select"
                            ? _c("ma-input-select", {
                                attrs: {
                                  type: "select",
                                  name: component.id,
                                  col: 4,
                                  literal: component.literal,
                                  options: component.options,
                                  value: component.value,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : component.type === "check" ||
                              component.type === "multicheck"
                            ? _c("ma-input-checkbox", {
                                attrs: {
                                  type: component.type,
                                  name: component.id,
                                  col: "4",
                                  literal: component.literal,
                                  options: component.options,
                                  value: component.value,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                  input: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : component.type === "radio"
                            ? _c("ma-input-radio", {
                                attrs: {
                                  col: "4",
                                  type: component.type,
                                  name: component.id,
                                  literal: component.literal,
                                  options: component.options,
                                  value: component.value,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                  input: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : component.type === "image_button"
                            ? _c("ma-input-imgradio", {
                                attrs: {
                                  type: "imgRadio",
                                  name: component.id,
                                  col: "4",
                                  literal: component.literal,
                                  options: component.options,
                                  value: component.value,
                                  isExternalImage: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                  input: function ($event) {
                                    return _vm.setComponentValue(
                                      $event,
                                      component
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      : component.id === "titleAuxPlombier"
                      ? _c("ma-info-box", {
                          attrs: {
                            title: component.literal,
                            description: _vm.dataComponents.find(
                              (c) => c.id === "textAuxPlombier"
                            ).literal,
                          },
                        })
                      : _vm._e(),
                    component.hint
                      ? _c(
                          "div",
                          { staticClass: "container-hint" },
                          [
                            _c("svgicon", {
                              staticClass: "mg mg--r-1",
                              attrs: {
                                name: "Info",
                                height: "12",
                                widht: "12",
                                color: "#5F646C",
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "text-small mg mg--t-1 gray" },
                              [_vm._v(_vm._s(component.hint))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "view_actions" }, [
      _vm.areAvailableConnections
        ? _c(
            "div",
            { staticClass: "fnol-buttons container-btn-blue grid__row" },
            _vm._l(_vm.availableConnections, function (connection) {
              return _c(
                "button",
                {
                  staticClass: "btn mainBlue",
                  attrs: { disabled: !_vm.checkIfFilled },
                  on: {
                    click: function ($event) {
                      return _vm.clickConnection(connection.id)
                    },
                  },
                },
                [_vm._v(_vm._s(connection.literal || ""))]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }